import { Gem } from 'lucide-react';
import { getImageUrl } from '@/utils/api';

// Small thumbnail used wherever we list stone requirements. Falls back to a
// centred Gem glyph when the requirement has no sample image yet, so the
// layout never collapses to nothing.
export default function HeroThumb({ image, size = 44, className = '' }) {
  const url = image ? getImageUrl(image) : null;
  const dim = { width: size, height: size };
  if (url) {
    return (
      <img src={url} alt="" style={dim}
        className={`rounded-lg object-cover border border-slate-200 bg-slate-50 shrink-0 ${className}`}
        onError={(e) => { e.currentTarget.style.display = 'none'; }} />
    );
  }
  return (
    <div style={dim}
      className={`rounded-lg flex items-center justify-center bg-gradient-to-br from-slate-100 to-slate-200 text-slate-400 border border-slate-200 shrink-0 ${className}`}>
      <Gem size={size * 0.45} />
    </div>
  );
}
